import {  useState, useEffect } from 'react';

import { reportarError, guardarDatoLocal, esformatoNumero, getParamsLink, showMensajePantalla, setFlagUpdate, recuperarDatoLocal, dividirListaNueva, dividirLista, borrarLocalStorage, superaTiempoDefinido} from '../helpers/funciones';
import { APP_ES_PRODUCCION, ID_MODULO_ADMIN_CANCHAS, ID_MODULO_ADMIN_CONFIGURACION, ID_MODULO_ADMIN_JUGADORES, ID_MODULO_ADMIN_TORNEO, ID_MODULO_BASE, ID_MODULO_CONSULTA_SERVIDOR, ID_MODULO_DETALLE_EQUIPO, ID_MODULO_DETALLE_JUGADOR, ID_MODULO_DETALLE_PARTIDO, ID_MODULO_DETALLE_TORNEO, ID_MODULO_GESTION_MICUENTA, ID_MODULO_INFO_COBROS, ID_MODULO_INFO_COBROS_JUGADOR, ID_MODULO_INFO_EQUIPO, ID_MODULO_INFO_JUGADOR, ID_MODULO_INFO_MENSAJES, ID_MODULO_PRINCIPAL_ADMIN, ID_MODULO_PRINCIPAL_INVITADO, ID_MODULO_PRINCIPAL_JUGADOR, SERVIDOR_PRINCIPAL, SERVIDOR_PRUEBAS } from '../constantes/generales';

import Main from './Main';
import Detalle_Torneo from "./Detalle_Torneo";
import Detalle_Partido from './Detalle_Partido';
import Detalle_Equipo from './Detalle_Equipo';
import Detalle_Jugador from './Detalle_Jugador';
import Principal_Jugador from './Principal_Jugador';
import Principal_Invitados from "./Principal_Invitados";
import Info_Equipo from './Info_Equipo';
import Admin_Jugadores from './Admin_Jugadores';
import Info_Jugador from './Info_Jugador';
import Gestion_MiCuenta from './Gestion_MiCuenta';
import Info_Cobros from './Info_Cobros';
import Info_Cobros_Jugador from './Info_Cobros_Jugador';
import { useParams } from 'react-router-dom';
import Info_Mensajes from './Info_Mensajes';
import { messaging } from '../firebase';
import { onMessage } from 'firebase/messaging';
import Principal_Admin from './Principal_Admin';
import Admin_Torneo from './Admin_Torneo';
import Admin_Configuracion from './Admin_Configuracion';
import Get_Servidor from './Get_Servidor';
import Admin_Canchas from './Admin_Canchas';

let ventanaMensaje;

const nomClase="Inicial_WB";
//const idModulo="0";

let tiempo="";


const Inicial = () => {
    const [paramOrigen, setParamOrigen] = useState("");
    const [paramDestino, setParamDestino] = useState("");
    const [moduloOrigen, setModuloOrigen] = useState(-1);
    const [moduloDestino, setModuloDestino] = useState(ID_MODULO_BASE);    
    const [recuperarServidor, setRecuperarServidor] = useState(false);  

    const [showMensaje, setShowMensaje] = useState(false);

    let params = useParams();

    let presentar=false;
   
  

    const cerrarVentana=() => {
        setShowMensaje(false);
        setFlagUpdate(true);
        setModuloDestino(ID_MODULO_BASE);     
    }


    const onPop=(e)=>{
        window.history.pushState("","","/");
        definirModulo(0,0,"",ID_MODULO_BASE,"");
    }


    useEffect(() => {
        const nomFuncion="useEffect";

        try{   
            //alert("useEffect Inicial.js");

            borrarLocalStorage();

            escucharMsj();

            window.addEventListener('popstate',onPop);

            
            let hayEmpresa=false;
            let haySede=false;
            let hayTorneo=false;
            let hayNotificacion=false;

            if(moduloOrigen===-1){
                setModuloOrigen(0);
                
                if(Object.keys(params).length>0){
                    let getParams=getParamsLink(params.dato);
                                       
                    if(getParams[0]==="E" && esformatoNumero(getParams[1])) hayEmpresa=true;
                    else if(getParams[0]==="S" && esformatoNumero(getParams[1])) haySede=true;
                    else if(getParams[0]==="T" && esformatoNumero(getParams[1])) hayTorneo=true;
                    else if(getParams[0][0]==="N" && getParams[1]!=="") hayNotificacion=true;

                    if(hayEmpresa || haySede){
                        setParamDestino(getParams[0] + "#" + getParams[1]);
                        setModuloDestino(ID_MODULO_PRINCIPAL_INVITADO);
                    }
                    else if(hayTorneo){
                        setParamDestino(getParams[1]);
                        setModuloDestino(ID_MODULO_DETALLE_TORNEO);
                        guardarDatoLocal("esLinkTorneo","1");
                    }
                    else if(hayNotificacion){
                        if(getParams[0]==="NG"){
                            //ventanaMensaje=showMensajePantalla("NOTIFICACION RECIBIDA","Notificacion Generica",setShowMensaje,null,"ALERTA","");
                            let SEP = "$";
                            let datos = dividirLista(getParams[1], SEP, 3);
                            let url="";

                            if(url.toLowerCase().includes("http")){
                                //averiguar como abrir url sin dar click
                            }
                        }
                        else if(getParams[0]==="NP"){
                            //ventanaMensaje=showMensajePantalla("NOTIFICACION RECIBIDA","Notificacion de Partido",setShowMensaje,null,"ALERTA","");

                            let SEP = "$";
                            let datos = dividirLista(getParams[1], SEP, 5);

                            //Guardar datos de la notificacion
                            if(esformatoNumero(datos[2])) guardarDatoLocal("idTorneoNotificacion",datos[2]);  
                            else guardarDatoLocal("idTorneoNotificacion","");                             
                            
                            setFlagUpdate(true);
                            setModuloDestino(ID_MODULO_BASE);
                        }

                        
                    }
                    else{
                        ventanaMensaje=showMensajePantalla("LINK INCORRECTO","El Link ingresado NO es valido, por favor verifique la información e intente nuevamente.",setShowMensaje,null,"ERROR","");
                    }

                }
                
            } 

            let recuperar=consultarInfoServidor();
            if(recuperar) setRecuperarServidor(true);

   
           return () =>{
            window.removeEventListener("popstate", onPop);
            } 

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }        

    }, []);


    const escucharMsj = async (dispatch) => {
        const nomFuncion="escucharMsj";

        try {
            if(recuperarDatoLocal("browserSoportado")==="1"){

                const messagingResolve = await messaging;
        
                if(messagingResolve!==null){

                    onMessage(messagingResolve, payload => {

                        let titulo= "";
                        if(payload.data.hasOwnProperty("title")) titulo=payload.data.title;
                        let body= "";
                        if(payload.data.hasOwnProperty("body")) body=payload.data.body;
                        
                        let idsede= "";
                        if(payload.data.hasOwnProperty("idsede")) idsede=payload.data.idsede;
                        let idtorneo= "";
                        if(payload.data.hasOwnProperty("idtorneo")) idtorneo=payload.data.idtorneo;
                        let idpartido= "";
                        if(payload.data.hasOwnProperty("idpartido")) idpartido=payload.data.idpartido;
                        let idrol= "";
                        if(payload.data.hasOwnProperty("idrol")) idrol=payload.data.idrol;
                    

                        if(idpartido!=="" && idrol==="4"){
                            if(esformatoNumero(idtorneo)) guardarDatoLocal("idTorneoNotificacion",idtorneo);  
                            else guardarDatoLocal("idTorneoNotificacion","");                             
                        }

                    
                        if(titulo!==""){
                            ventanaMensaje=showMensajePantalla(titulo,body,setShowMensaje,cerrarVentana,"INFO",""); 
                        }
                           
                            
                         
                    });
                }

            }
            
        } catch (err) {
            reportarError( nomClase, nomFuncion, "", err);
        }
    };

    const definirModulo = (registro, modOrigen, paramOrigen, modDestino, paramDestino) => {


        let recuperar=false;

        if(recuperarDatoLocal("ConsultarServidor")===true) recuperar=true;
        else{
            if(registro!==-100){
                recuperar=consultarInfoServidor();
            } 
        }               

        if(recuperar){
            setParamOrigen(paramOrigen);
            setParamDestino(paramDestino);
            setModuloOrigen(modOrigen);
            setModuloDestino(modDestino); 

            setRecuperarServidor(true);
        }
        else{
            setRecuperarServidor(false);

            if(modDestino!==ID_MODULO_BASE && modDestino!==ID_MODULO_PRINCIPAL_JUGADOR && modDestino!==ID_MODULO_PRINCIPAL_INVITADO && 
                modDestino!==ID_MODULO_DETALLE_TORNEO && modDestino!==ID_MODULO_DETALLE_PARTIDO && modDestino!==ID_MODULO_DETALLE_EQUIPO && 
                modDestino!==ID_MODULO_DETALLE_JUGADOR && modDestino!==ID_MODULO_INFO_EQUIPO && modDestino!==ID_MODULO_ADMIN_JUGADORES && 
                modDestino!==ID_MODULO_INFO_JUGADOR && modDestino!==ID_MODULO_GESTION_MICUENTA && modDestino!==ID_MODULO_INFO_COBROS &&
                modDestino!==ID_MODULO_INFO_COBROS_JUGADOR && modDestino!==ID_MODULO_INFO_MENSAJES && modDestino!==ID_MODULO_PRINCIPAL_ADMIN &&
                modDestino!==ID_MODULO_ADMIN_TORNEO && modDestino!==ID_MODULO_ADMIN_CONFIGURACION && modDestino!==ID_MODULO_ADMIN_CANCHAS){
                    modDestino=ID_MODULO_BASE;
            }  

            setParamOrigen(paramOrigen);
            setParamDestino(paramDestino);
            setModuloOrigen(modOrigen);
            setModuloDestino(modDestino);  
        }

              
    }

    const consultarInfoServidor =  () => {
        const nomFuncion="consultarInfoServidor";

        let respuesta=false;
        try {

            let serverActual=recuperarDatoLocal("ServidorMarcaGolWeb");

            if(serverActual==="" || superaTiempoDefinido("ultAcceso" + ID_MODULO_CONSULTA_SERVIDOR,60,"MINUTOS")){
                if(APP_ES_PRODUCCION===false){
                    guardarDatoLocal("ServidorMarcaGolWeb",SERVIDOR_PRUEBAS);
                    guardarDatoLocal("rutaRecursos",SERVIDOR_PRUEBAS + "recursos/");   
                    guardarDatoLocal("ultAcceso" + ID_MODULO_CONSULTA_SERVIDOR,Date.now());                  
                }
                else{
                    respuesta=true;
                    tiempo=Date.now();
                }
                
            }
            
            
        } catch (err) {
            reportarError( nomClase, nomFuncion, "", err);
        }

        return respuesta;
    };

    
    if(moduloOrigen===-1) return(<></>);

    
    return (
        <>
        {recuperarServidor ? (
            <Get_Servidor params={tiempo} modOrigen={moduloOrigen} paramOrigen={paramOrigen} modDestino={moduloDestino} paramDestino={paramDestino} definirModulo={definirModulo} />
        ) :
        (
            <>
                {showMensaje && (ventanaMensaje)}

                {moduloDestino===ID_MODULO_BASE && (
                    <Main  definirModulo={definirModulo}/>
                )}

                {(moduloDestino===ID_MODULO_PRINCIPAL_JUGADOR) && (
                    <Principal_Jugador params={paramDestino} definirModulo={definirModulo} />
                )}

                {(moduloDestino===ID_MODULO_PRINCIPAL_ADMIN) && (
                    <Principal_Admin params={paramDestino} definirModulo={definirModulo} />
                )}

                {(moduloDestino===ID_MODULO_PRINCIPAL_INVITADO) && (
                    <Principal_Invitados params={paramDestino}  modOrigen={moduloOrigen} paramOrigen={paramOrigen} definirModulo={definirModulo}/>
                )}

                {moduloDestino===ID_MODULO_DETALLE_TORNEO && (
                    <Detalle_Torneo params={paramDestino} modOrigen={moduloOrigen} paramOrigen={paramOrigen}  definirModulo={definirModulo} />
                )}

                {moduloDestino===ID_MODULO_DETALLE_PARTIDO && (
                    <Detalle_Partido params={paramDestino} modOrigen={moduloOrigen} paramOrigen={paramOrigen} definirModulo={definirModulo} />
                )}  

                {moduloDestino===ID_MODULO_DETALLE_EQUIPO && (
                    <Detalle_Equipo params={paramDestino} modOrigen={moduloOrigen} paramOrigen={paramOrigen} definirModulo={definirModulo} />
                )}  

                {moduloDestino===ID_MODULO_DETALLE_JUGADOR && (
                    <Detalle_Jugador params={paramDestino} modOrigen={moduloOrigen} paramOrigen={paramOrigen} definirModulo={definirModulo} />
                )}  

                {moduloDestino===ID_MODULO_INFO_EQUIPO && (
                    <Info_Equipo params={paramDestino} modOrigen={moduloOrigen} paramOrigen={paramOrigen} definirModulo={definirModulo} />
                )}  

                {moduloDestino===ID_MODULO_INFO_JUGADOR && (
                    <Info_Jugador params={paramDestino} modOrigen={moduloOrigen} paramOrigen={paramOrigen} definirModulo={definirModulo} />
                )}  

                {moduloDestino===ID_MODULO_GESTION_MICUENTA && (
                    <Gestion_MiCuenta params={paramDestino} modOrigen={moduloOrigen} paramOrigen={paramOrigen} definirModulo={definirModulo} />
                )} 

                {moduloDestino===ID_MODULO_INFO_COBROS && (
                    <Info_Cobros params={paramDestino} modOrigen={moduloOrigen} paramOrigen={paramOrigen} definirModulo={definirModulo} />
                )} 

                {moduloDestino===ID_MODULO_INFO_COBROS_JUGADOR && (
                    <Info_Cobros_Jugador params={paramDestino} modOrigen={moduloOrigen} paramOrigen={paramOrigen} definirModulo={definirModulo} />
                )} 

                {moduloDestino===ID_MODULO_ADMIN_JUGADORES && (
                    <Admin_Jugadores params={paramDestino} modOrigen={moduloOrigen} paramOrigen={paramOrigen} definirModulo={definirModulo} />
                )} 

                {moduloDestino===ID_MODULO_INFO_MENSAJES && (
                    <Info_Mensajes params={paramDestino} modOrigen={moduloOrigen} paramOrigen={paramOrigen} definirModulo={definirModulo} />
                )} 

                {moduloDestino===ID_MODULO_ADMIN_TORNEO && (
                    <Admin_Torneo params={paramDestino} modOrigen={moduloOrigen} paramOrigen={paramOrigen} definirModulo={definirModulo} />
                )} 

                {moduloDestino===ID_MODULO_ADMIN_CONFIGURACION && (
                    <Admin_Configuracion params={paramDestino} modOrigen={moduloOrigen} paramOrigen={paramOrigen} definirModulo={definirModulo} />
                )} 

                {moduloDestino===ID_MODULO_ADMIN_CANCHAS && (
                    <Admin_Canchas params={paramDestino} modOrigen={moduloOrigen} paramOrigen={paramOrigen} definirModulo={definirModulo} />
                )} 
            </>
        )}

        
           
        </>
    );

};

export default Inicial;